export enum Breakpoint {
	B3 = '374px',
	B4 = '450px',
	B5 = '576px',
	B6 = '640px',
	B7 = '768px',
	B9 = '900px',
	B10 = '1023px',
	B12 = '1280px'
};